<template>
    <v-dialog v-model="dialog" max-width="300px" @keydown="closeModal" @click:outside="closeModal">
        <template v-slot:activator="{ on, attrs }">
            <label v-bind="attrs" v-on="on" :style="[{color: keyChecked ? '#960C0C' : '#2B1C1C'}]" class="py-1 d-flex align-center ma-auto justify-space-between outer-label">
                <input type="checkbox"
                       style="display: none"
                       :name="filterData.label"
                       :id="filterData.label"
                       @change="select">
                {{filterData.label}}
                <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 13.5L7 7.5L1 1.5" :stroke="keyChecked ? '#960C0C' : '#000'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

            </label>
        </template>
        <v-card class="pa-10">
            <div>
                <span @click="closeModal" class="d-flex align-center mb-3 close-modal">
                    <v-img class="mr-3" max-height="16" max-width="16"
                           src="../../../../../../assets/svg/CloseModalIcon.svg"/>
                    Back
                </span>
                <p style="text-align: center; font-weight: bold">{{filterData.label}}</p>
            </div>
            <label v-for="option in filterData.options"
                   :key="option"
                   :for="option"
                   class="d-flex align-center">
                <input type="checkbox"
                       style="display: none"
                       :name="option"
                       :id="option"
                       @change="[updateFilterCondition(option)]">
                <svg class="mr-4" width="15" height="15" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 2.75C0.75 1.92157 1.42157 1.25 2.25 1.25H21.75C22.5784 1.25 23.25 1.92157 23.25 2.75V22.25C23.25 23.0784 22.5784 23.75 21.75 23.75H2.25C1.42157 23.75 0.75 23.0784 0.75 22.25V2.75Z" :fill="filterConditions[filterData.label].option.indexOf(option) !== -1 ? '#960C0C' : '#FFF'" stroke="#960C0C" stroke-width="1.5"/>
                    <path v-if="filterConditions[filterData.label].option.indexOf(option) !== -1" d="M18.6674 7.5L9.50077 16.6667L5.33411 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{option}}
            </label>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "FilterInnerModal",
        data: () => ({
            dialog: false,
            optionChecked: false
        }),
        methods: {
            ...mapActions([
                'setFilterConditionsWithOption',
                'pushToCurrentChecks',
                'removeFromCurrentChecks'
            ]),
            select() {
                const {filterData,} = this
                filterData.selected = !filterData.selected
                this.dialog = filterData.selected
                if (filterData.selected) {
                    this.pushToCurrentChecks(filterData.label)
                }
                else {
                    this.removeFromCurrentChecks(this.filterData.label)
                    this.setFilterConditionsWithOption({label: filterData.label, action: 'clear'})
                }
            },
            updateFilterCondition(option) {
                const {label,} = this.filterData
                if (this.filterConditions[label].option.indexOf(option) !== -1)
                    this.setFilterConditionsWithOption({label: label, options: option, action: 'remove'})
                else this.setFilterConditionsWithOption({label: label, options: option, action: 'push'})
            },
            closeModal() {
                const {label,} = this.filterData
                if (this.filterConditions[label].option.length === 0) {
                    this.removeFromCurrentChecks(label)
                    this.filterData.selected = false
                }
                this.dialog = false
            }
        },
        computed: {
            ...mapGetters(['filterConditions', 'currentChecks']),
            keyChecked() {
                return this.currentChecks.indexOf(this.filterData.label) !== -1
            },
        },
        props: {
            filterData: Object,
        }
    }
</script>

<style scoped>
    .close-modal, label {
        cursor: pointer;
    }

    .outer-label {
        width: 85%;
    }
</style>